import React from "react";
import "./Sidebar.css";
import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io";
import * as HiIcons from "react-icons/hi";
import * as MdIcons from "react-icons/md";
import * as BsIcons from "react-icons/bs";
import * as TbIcons from "react-icons/tb";
import * as RiIcons from "react-icons/ri";
import * as AiIcons from "react-icons/ai";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/Admin/Dashboard",
    icon: <MdIcons.MdSpaceDashboard />,
    cName: "nav-text",
  },
  {
    title: "Customers",
    path: "#",
    icon: <FaIcons.FaUserFriends />,
    cName: "nav-text",
    iconClosed: <IoIcons.IoMdArrowDropdown/>,
    iconOpened: <IoIcons.IoMdArrowDropup/>,
    subNav: [
    {
    title: "Active Customers",
    path: "/Admin/Customers",
    icon: <MdIcons.MdKeyboardArrowRight />,
    cName: "nav-subtext",
    },
    {
      title: "Archived Customers",
      path: "/Admin/ArchivedCustomers",
      icon: <MdIcons.MdKeyboardArrowRight />,
      cName: "nav-subtext",
    }
    ]
  },
  {
    title: "Orders",
    path: "/Admin/Orders",
    icon: <BsIcons.BsCartFill />,
    cName: "nav-text",
  },
  {
    title: "Investigators",
    path: "/Admin/Investigators",
    icon: <MdIcons.MdPersonSearch />,
    cName: "nav-text",
  },
  {
    title: "Reports",
    path: "/Admin/Reports",
    icon: <AiIcons.AiFillFund />,
    cName: "nav-text",
  },
  {
    title: "Template",
    path: "#",
    icon: <AiIcons.AiFillLayout />,
    cName: "nav-text",
    iconClosed: <IoIcons.IoMdArrowDropdown/>,
    iconOpened: <IoIcons.IoMdArrowDropup/>,
    subNav: [
    {
    title: "Report Templates",
    path: "/Admin/ReportTemplates",
    icon: <MdIcons.MdKeyboardArrowRight />,
    cName: "nav-subtext",
    },
    {
      title: "Form Templates",
      path: "/Admin/FormTemplates",
      icon: <MdIcons.MdKeyboardArrowRight />,
      cName: "nav-subtext",
    }
    ]
  },
  {
    title: "Notifications",
    path: "/Admin/AdminNotifications",
    icon: <IoIcons.IoMdNotifications />,
    cName: "nav-text",
  },
  {
    title: "Logout",
    path: "/",
    icon: <RiIcons.RiLogoutCircleRLine />,
    cName: "nav-text"
  },
];
